import {Checkbox, Divider, Flex, Input, Radio, Typography} from "antd";
import React, {useEffect} from "react";
import {concourseGroupsStore, resultStore} from "../../../store/admissions/admissionStore";
import UploadDoc from "../component/UploadDoc";
import {stepsStore} from "../../../store/admissions/stepperStore";
import {categories} from "../model/categories";
import {achievements} from "../model/achievements";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";

const style: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
};

export default function Step9() {
    const {stepsData, setStepsData} = stepsStore();
    const {result, setResult} = resultStore();
    const {concourseGroups, setConcourseGroups} = concourseGroupsStore();
    const {xl} = useBreakpoint()

    useEffect(() => {
        setStepsData({...stepsData, nextStep: true})
    }, []);

    function UploadItem(props: any) {
        return (
            <Flex gap={24} style={{width: "100%"}} align={"center"} justify={"center"}>
                <Flex style={{width: "50%"}} justify={"flex-end"}>
                    <Typography.Text>{`${props.title}:`}</Typography.Text>
                </Flex>
                <Flex style={{width: "50%"}} align={"center"} justify={"flex-start"} gap={16}>
                    <UploadDoc id={`${props.code}_F`} onFileChange={() => {
                    }}/>
                </Flex>
            </Flex>
        )
    }

    return (
        <Flex vertical justify={"center"} align={"center"} gap={24} style={{width: xl ? '70%' : '100%'}}>
            <Flex vertical={true} gap={24} align={"center"} justify={"center"}>
                {(result.kindsLevelFormation !== "000000008" && result.kindsLevelFormation !== "000000003") &&
                    <Flex vertical={true} gap={16} align={"center"} justify={"center"}>
                        <Flex vertical={true} gap={8} align={"center"}>
                            <Typography.Text strong style={{fontSize: 18}}>Загрузите документы подтверждающие вашу
                                категорию</Typography.Text>
                            {!result.categories["notany"] &&
                                <Typography.Text>(файлы формата .pdf, .jpg, .jpeg, .png и .zip размером до
                                    5мб)</Typography.Text>}
                        </Flex>
                        {result.categories["notany"] ?
                            <Flex>
                                Категории не были выбраны
                            </Flex>
                            :
                            <Flex vertical gap={8} align={"center"} justify={"center"}>
                                {Object.keys(result.categories).map(item => {
                                    if (result.categories[item]) {
                                        return <UploadItem
                                            code={item}
                                            title={categories.get(result.kindsLevelFormation)?.find(category => category.code === item)?.display}
                                            help={item}/>
                                    }
                                })}
                            </Flex>
                        }
                    </Flex>
                }
            </Flex>
            <Flex vertical={true} gap={24} align={"center"} justify={"center"}>
                {(result.kindsLevelFormation !== "000000008" && result.kindsLevelFormation !== "000000003") &&
                    <Flex vertical={true} gap={16} align={"center"} justify={"center"}>
                        <Flex vertical={true} gap={8} align={"center"}>
                            <Typography.Text strong style={{fontSize: 18}}>Загрузите документы подтверждающие ваши
                                достижения</Typography.Text>
                            {!result.achievements["notany"] &&
                                <Typography.Text>(файлы формата .pdf, .jpg, .jpeg, .png и .zip размером до
                                    5мб)</Typography.Text>}
                        </Flex>
                        {result.achievements["notany"] ?
                            <Flex>
                                Достижения не были указаны
                            </Flex>
                            :
                            <Flex vertical gap={8} align={"center"} justify={"center"}>
                                {Object.keys(result.achievements).map(item => {
                                    if (result.achievements[item]) {
                                        return <UploadItem
                                            code={item}
                                            title={achievements.get(result.kindsLevelFormation)?.find(achievemen => achievemen.code === item)?.display}
                                            help={item}/>
                                    }
                                })}
                            </Flex>
                        }
                    </Flex>
                }
            </Flex>
            <Divider style={{margin: 4}}/>
            <Flex justify={"center"} align={"center"} style={{width: xl ? '50%' : '100%'}} gap={12}>
                {(result.kindsLevelFormation !== "000000008" && result.kindsLevelFormation !== "000000003") ?
                    <Typography.Text style={{fontSize: 16}}>Файлы, содержащие дополнительную
                        информацию:</Typography.Text> :
                    <Typography.Text style={{fontSize: 16}}>Вы можете загрузить файлы, содержащие дополнительную
                        информацию:</Typography.Text>
                }
                <UploadDoc maxCount={true} onFileChange={() => {
                }}/>
            </Flex>
            {concourseGroups.filter(item => result.selectedConcourceGroupsCodes.includes(item.concourseGroupsCode)).find(item => item.competitioncode === "ЦЕЛЕВОЙПРИЕМ") &&
                <Flex
                    vertical={true}
                    style={{width: '100%'}}
                    justify={'center'}
                    align={'center'}>

                    <Divider style={{margin: 4}}/>
                    <Flex
                        vertical={true}
                        style={{width: '100%'}}
                        justify={'center'}
                        align={'center'}
                        gap={16}
                    >
                        <Typography.Text strong>Укажите номер предложения на целевое обучение</Typography.Text>
                        <Flex align={"center"} justify={"center"}>
                            <Typography.Text style={{width: '100%'}}>Номер предложения</Typography.Text>
                            <Input onChange={(value) => {
                                setResult({
                                    ...result,
                                    offernumber: value.target.value
                                })
                            }}/>
                        </Flex>
                        <Flex vertical>
                            <Radio.Group
                                style={style}
                                onChange={(value) => {
                                    setResult({
                                        ...result,
                                        offernumberposted: value.target.value
                                    })
                                }}
                                options={[
                                    {
                                        value: true,
                                        label: "Предложение размещено на сайте \"Работа в России\""
                                    },
                                    {
                                        value: false,
                                        label: "Предложение НЕ размещено на сайте \"Работа в России\""
                                    }
                                ]}
                            />
                        </Flex>
                    </Flex>
                </Flex>
            }
            <Divider style={{margin: 4}}/>
            <Flex
                vertical={true}
                style={{width: '100%'}}
                justify={'center'}
                align={'center'}
                gap={16}
            >
                <Typography.Text strong>Укажите пожелания по общежитию</Typography.Text>
                <Checkbox
                    defaultChecked={result.needador}
                    onChange={(event) => {
                        setResult({
                            ...result,
                            needador: event.target.checked
                        })
                    }}>Мне нужно общежитие</Checkbox>
            </Flex>
        </Flex>
    )
}